import type { Chapter, VideoData } from "../types";

export const getVideoChapterByCurrentTime = (
  chapters: VideoData["chapters"],
  currentTimeInMilliSeconds: number
): Chapter | undefined => {
  if (chapters === undefined || chapters.length === 0) {
    return undefined;
  }

  const filteredChapters = chapters.filter(
    (chapter) => chapter.startTimeInMilliseconds <= currentTimeInMilliSeconds
  );
  if (filteredChapters.length === 0) return undefined;

  return filteredChapters.reduce((prev, current) => {
    return prev.startTimeInMilliseconds > current.startTimeInMilliseconds
      ? prev
      : current;
  });
};
